<template>
  <el-form-item
    :label="label"
    class="numeric"
    :prop="prop"
    :rules="rules"
  >
    <el-input-number
      class="no-spin"
      v-model="numeric"
      controls-position="right"
      :maxlength="5"
      :placeholder="placeholder"
      :disabled="disabled"
      :min="min"
      :max="max"
      :precision="precision"
      :step="step"
      :autofocus="autofocus"
    />
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {
  },
  mixins: [
    Validator
  ],
  props: {
    value: Number,
    label: {
      type: String,
      default: ''
    },
    prop: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 9999999999
    },
    precision: {
      type: Number,
      default: 0
    },
    step: {
      type: Number,
      default: 1
    },
    placeholder: String
  },
  data () {
    return {
    }
  },
  computed: {
    numeric: {
      get () {
        if (this.value === null) {
          return undefined
        }
        return this.value
      },
      set (numeric) {
        this.$emit('input', numeric)
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'blur'))
          }
        }
        return rules
      }
    }
  },
  mounted () {
    const inner = this.$el.querySelector('.el-input__inner')
    inner.setAttribute('maxlength', '100')
  },
  methods: {
  }
}
</script>
<style lang="scss">
.el-form-item {
  &.numeric {
    .el-form-item__content {
      .el-input-number {
        width: 10em;
        .el-input-number__decrease,.el-input-number__increase {
          display: none;
        }
        .el-input{
          .el-input__inner{
            text-align:left;
            // padding-right: 28px;
          }
        }
      }
    }
  }
}
.el-input-number.is-controls-right .el-input__inner {
  padding-right: 28px !important;
}
</style>
